import { Link, Stack, Typography } from "@mui/material";
import Marquee from "react-fast-marquee";
import Application_Form from "../../assets/pdfs/spotlight/Application_Format_staff_selection.pdf";
import link4 from "../../assets/pdfs/spotlight/UG_Admission_2024-2025.pdf";
import link5 from "../../assets/pdfs/spotlight/PG_Admission_2024-2025.pdf";
import link1 from "../../assets/pdfs/spotlight/Quota wise merit list 1st MPTh AY 2425 DTD 11.11.24.pdf";
import link2 from "../../assets/pdfs/spotlight/selected candidate list 1year MPTh DTD 11.11.24.pdf";
import link3 from "../../assets/pdfs/spotlight/Wait list 1 St PG MPTh AY 2425 DTD 11.11.24.pdf";
import link6 from "../../assets/pdfs/spotlight/2nd quota wise candidates list for institutional level round.pdf";
import link7 from "../../assets/pdfs/spotlight/2nd selected list for institutional level round.pdf";
import link8 from "../../assets/pdfs/spotlight/FRA2025-26.pdf";
import link9 from "../../assets/pdfs/spotlight/NEET-UG25 brocher.pdf";
import link10 from "../../assets/pdfs/spotlight/Notice.pdf";
import link11 from "../../assets/pdfs/spotlight/Notice No.24_UG Allied_Group C_CAP Round 3.pdf"
import link12 from "../../assets/pdfs/spotlight/FRA BPTh- UG fees 2025-2026.pdf";
import link13 from "../../assets/pdfs/spotlight/FRA MPT- PG fees 2025-2026.pdf";
import link14 from "../../assets/pdfs/spotlight/FRA- Fee Structure PG AY 2025-26.pdf";
import link15 from "../../assets/pdfs/spotlight/FRA- Fee Structure UG AY 2025-26.pdf";
import link16 from "../../assets/pdfs/spotlight/Notice32.pdf";
import link17 from "../../assets/pdfs/spotlight/Institue quto 25-26 gernal merti list.pdf";
import link18 from "../../assets/pdfs/spotlight/Institue quto 25-26 selection list.pdf";
import link19 from "../../assets/pdfs/spotlight/Fee Proposal A.Y. 2026-2027 (1).pdf";
import link20 from "../../assets/pdfs/spotlight/waitlist25_26.pdf";
import link21 from "../../assets/pdfs/spotlight/SelectionList25_26.pdf";
import link22 from "../../assets/pdfs/spotlight/quotawisemeritlist.pdf";
import link23 from "../../assets/pdfs/spotlight/GeneralMeritList2526.pdf";
import link24 from "../../assets/pdfs/spotlight/generalList.pdf";
import link25 from "../../assets/pdfs/spotlight/SELECTEDCANDIDATESVACANCYANDINSTROUND25_26PG1.pdf";
import link26 from "../../assets/pdfs/spotlight/SecondSelectionlist12_01_2026.pdf";
import link27 from "../../assets/pdfs/spotlight/Feesdeatils2526UG.pdf";
import link28 from "../../assets/pdfs/spotlight/Feesdeatils25_26PG.pdf";
import link29 from "../../assets/pdfs/spotlight/Group_B_and_C_Notice_no_13.pdf";

import { keyframes } from "@emotion/react";

const blinkAnimation = keyframes`
  50% {
    opacity: 0;
  }
`;

const spotlightItems = [
  // { label: "General List MPT- PG AY 2025-2026", url: link24, newTag: true },
  //  { label: "Selection List MPT - PG AY 2025-2026", url: link26, newTag: true },
  //  { label: "Quota wise List MPT-PG AY 2025-2026", url: link22, newTag: true },
  //  { label: "Wait List MPT - PG AY 2025-2026", url: link20, newTag: true },
  // { label: "General List BPTH -UG AY 2025-2026", url: link17, newTag: true },
  // { label: "Selection List BPTH-UG AY 2025-2026", url: link18, newTag: true },
  { label: "Online Fee proposal  for  AY 2026-2027", url: link19, newTag: true },

  { label: "FRA Fee structure BPTh-UG AY 2025-2026", url: link27, newTag: true },
  { label: "FRA Fee structure MPT-PG AY 2025-2026", url: link28, newTag: true },
  { label: "NEET UG 2026 NOTICE NO 13 Schedule of CAP Round-1", url: link29, newTag: true },
  // { label: "FRA online proposal 2025-2026", url: link8, newTag: true },
  // { label: "Information Brochure for the admissions A. Y. 2025-2026", url: link9, newTag: true },
  // { label: "Admission Schedule for CAP Round AY 25-26", url: link10, newTag: true },
  // { label: "Notice - NEET UG CAP Round 3 for A.Y. 2025-2026", url: link11, newTag: true },
  // { label: "FRA Fee structure BPTh -UG AY 2025-2026", url: link15, newTag: true },
  // { label: "FRA Fee structure MPT- PG  AY 2025-2026", url: link14, newTag: true },
  // { label: "Notice - NEET UG CAP Online Stray Vacancy Round Schedule for A.Y. 2025-2026", url: link16, newTag: true },

  // { label: "Application Form", url: Application_Form },
  // { label: "QUOTA WISE MERIT LIST 1ST YEAR MPTh 2024-2025", url: link1, newTag: true },
  // { label: "SELECTED CANDIDATES LIST FOR INSTITUTIONAL LEVEL  ROUND 1ST YEAR MPTh 2024-2025", url: link2, newTag: true,},  
  // { label: "WAITLIST FOR INSTITUTIONAL LEVEL ROUND 1ST YEAR MPTh 2024-2025",url: link3,newTag: true,},
  // { label: "UG Admission 2024-25", url: link4, newTag: true },
  // { label: "PG Admission 2024-25", url: link5, newTag: true },
  // { label: "2ND QUOTA WISE MERIT LIST 1ST YEAR MPTh 2024-2025", url: link6, newTag: true },
  // { label: "2ND SELECTED CANDIDATES LIST FOR INSTITUTIONAL LEVEL  ROUND 1ST YEAR MPTh 2024-2025", url: link7, newTag: true },
];

const SpotLight = () => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{ overflow: "hidden", backgroundColor: "secondary.light", p: 0.7 }}
    >
      <Typography
        variant="h6"
        sx={{
          backgroundColor: "primary.main",
          color: "white",
          p: 1,
          mr: 0,
          borderRadius: "4px",
        }}
      >
        SpotLight
      </Typography>

      <Marquee
        pauseOnHover
        style={{
          backgroundColor: "white",
          display: "flex",
          alignItems: "center",
          padding: "0 1rem",
        }}
      >
        {spotlightItems.map((item, index) => (
          <Link
            key={index}
            href={item.url}
            target="_blank"
            sx={{
              mx: 2,
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "primary.main",
              position: "relative",
              transition: "color 0.3s ease",
              "&:hover": {
                color: "primary.main",
              },
            }}
          >
            <Typography
              variant="body1"
              sx={{ display: "flex", alignItems: "center" }}
            >
              {`Click Here: ${item.label}`}
              {item.newTag && (
                <Typography
                  component="span"
                  sx={{
                    ml: 1,
                    backgroundColor: "red",
                    color: "white",
                    px: 0.8,
                    py: 0.15,
                    maxHeight: 10,
                    fontSize: "0.55rem",
                    borderRadius: "5px",
                    animation: `${blinkAnimation} 1s infinite`,
                    whiteSpace: "nowrap",
                    lineHeight: 1,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  NEW
                </Typography>
              )}
            </Typography>
          </Link>
        ))}
      </Marquee>
    </Stack>
  );
};

export default SpotLight;
